export default __webpack_public_path__ + "static/media/luis_team.9470856b.png";